import { useEffect, useMemo } from 'react';

import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';
import { useVote } from './hooks/useVote';

import MessagesList from './components/MessagesList/MessagesList';

import logo from './assets/images/logo.png';
import present from './assets/images/present.png';
import defaultBackground from './assets/images/bg.png';

import posterDefault from './assets/images/bgPoster.png';
import bgDefaultVideo from './assets/video/bgVideo.webm';

import advtVideo from './assets/video/advtVideo.webm';

import Advt from './components/Advt/Advt';
import { AnimatePresence, motion } from 'motion/react';
import AdvtSms from './components/AdvtSms/AdvtSms';

function App() {
  const { voteState, currentState, voteActivity: isVisible } = useVote();
  const { showedMessages, messagesRef, winnerMessage, speed, setSpeed } =
    useCarousel();

  const {
    authorFontSize,
    msgFontSize,
    phoneNumberFontSize,
    bgVideo,
    bgPoster,
    speedSlow,
    speedFast,
    bg,
  } = useGetParams();

  useEffect(() => {
    setTimeout(() => {
      if (currentState === 'S3' && speed !== speedSlow) {
        setSpeed(speedSlow);
      } else if (currentState === 'S4' && speed !== speedFast) {
        setSpeed(speedFast);
      }
    }, [500]);
  }, [currentState]);

  const prize = useMemo(() => {
    const isCorrect = voteState?.vars.find((v) => v.correct)?.varImgUrl;

    return isCorrect ? isCorrect : present;
  }, [voteState]);

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${bg === '1' ? defaultBackground : bg}) center/cover no-repeat`
      : `none`;
  }, [bg]);

  return (
    <div
      className="app-wrapper"
      style={{ '--speed': `${speed}ms`, background }}
    >
      <AnimatePresence mode="wait">
        {(currentState === 'S1' || currentState === 'S2') && (
          <motion.div
            key={`${currentState}-advt`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="motion"
          >
            {currentState === 'S1' && (
              <motion.div
                key="advtSms"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                className="motion"
              >
                <AdvtSms />
              </motion.div>
            )}

            {currentState === 'S2' && (
              <motion.div
                key="advt"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                className="motion"
              >
                <Advt />
              </motion.div>
            )}

            <video autoPlay muted loop id="bgVideo" style={{ zIndex: '-1' }}>
              <source src={advtVideo} type="video/webm" />
            </video>
          </motion.div>
        )}

        {['S3', 'S4', 'S5'].includes(currentState) && (
          <motion.div
            key="rnd"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="motion"
            style={{ display: 'flex' }}
          >
            <div className="presentBlock">
              <img src={logo} alt="logo" className="logo" />

              <AnimatePresence mode="wait">
                <motion.div
                  className="present"
                  key={prize}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 1, ease: 'easeInOut' }}
                >
                  <img src={prize} alt="prize" className="presentImg" />
                </motion.div>
              </AnimatePresence>
            </div>

            <MessagesList
              winId={winnerMessage?.message.id}
              messages={showedMessages}
              authorFontSize={authorFontSize}
              msgFontSize={msgFontSize}
              phoneNumberFontSize={phoneNumberFontSize}
              currentState={currentState}
              speed={speed || 0}
            />

            {bgVideo && (
              <video
                autoPlay="autoplay"
                muted="muted"
                loop
                poster={bgVideo === '1' ? posterDefault : bgPoster}
                id="bgVideo"
              >
                <source
                  src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
                  type="video/webm"
                ></source>
              </video>
            )}
          </motion.div>
        )}
      </AnimatePresence>

      <div id="img-loader" />
    </div>
  );
}

export default App;
